import { render, staticRenderFns } from "./GroupTitle.vue?vue&type=template&id=40d8bc33&scoped=true&"
import script from "./GroupTitle.vue?vue&type=script&lang=js&"
export * from "./GroupTitle.vue?vue&type=script&lang=js&"
import style0 from "./GroupTitle.vue?vue&type=style&index=0&id=40d8bc33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8bc33",
  null
  
)

export default component.exports